import React, { useRef } from 'react'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import ArrowNext from '../../../assets/images/front/svg/arrow-next-blue.svg'
import ArrowBg from '../../../assets/images/front/svg/slider-hp-bottom-arrow.svg'
import slider1image from '../../../assets/images/front/slider-1.png'
import slider2image from '../../../assets/images/front/slider-2.png'
import slider3image from '../../../assets/images/front/slider-3.png'
import slider4image from '../../../assets/images/front/slider-4.png'

const settings = {
  infinite: true,
  arrows: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  dots: false,
  swipeToSlide: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1
      }
    }
  ]
}

const HomepageSlider: React.FC = () => {
  const sliderRef = useRef<Slider | null>(null)
  const handleNext = () => {
    sliderRef.current?.slickNext()
  }

  return (
    <>
      <div className="w-full px-4 reviews px-4 lg:px-0">
        <div className="bottom-slider-container container mx-auto mt-[30px] md:mt-[60px] relative">
          <div className="bottom-slider">
            <Slider ref={sliderRef} {...settings}>
              <div className="px-1">
                {' '}
                <img src={slider1image} alt="" className="block w-full object-cover" />
              </div>
              <div className="px-1">
                {' '}
                <img src={slider2image} alt="" className="block w-full object-cover" />
              </div>
              <div className="px-1">
                {' '}
                <img src={slider3image} alt="" className="block w-full object-cover" />
              </div>
              <div className="px-1">
                {' '}
                <img src={slider4image} alt="" className="block w-full object-cover" />
              </div>
            </Slider>
          </div>

          <button
            className="absolute top-[-25px] -right-12 h-[calc(100%+50px)] bg-transparent border-none cursor-pointer w-[130px] flex items-center justify-center"
            onClick={handleNext}
            style={{ backgroundImage: `url(${ArrowBg})` }}
          >
            <img src={ArrowNext} alt="" />
          </button>
        </div>
      </div>
    </>
  )
}

export default HomepageSlider
